<!--Create Fleet Definition Title-->
<h2>Create Fleet Definition</h2>
<p>Account ID: {{createFleetDefinitionRequest.accountId}}</p>
<mat-dialog-content>
    <!--Dialog Content-->
    <div *ngIf="!createFleetDefinitionResponse">
        <form novalidate>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Fleet Kind</mat-label>
                    <mat-select [(ngModel)]="createFleetDefinitionRequest.fleetKind" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of fleetConstantClassCollection.fleetKindList" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Fleet Type</mat-label>
                    <mat-select [(ngModel)]="createFleetDefinitionRequest.fleetType" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of fleetConstantClassCollection.fleetTypeList" [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Image Name</mat-label>
                    <mat-select [(ngModel)]="createFleetDefinitionRequest.imageName" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let imageName of appStreamImages" [value]="imageName">
                            {{imageName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Instance Type</mat-label>
                    <mat-select [(ngModel)]="createFleetDefinitionRequest.instanceType" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of fleetConstantClassCollection.fleetInstanceTypeList"
                            [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Desired Instances</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.desiredInstances"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Min Capacity</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.minCapacity"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Max Capacity</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.maxCapacity"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Disconnect Timeout In Seconds</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.disconnectTimeoutInSeconds"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Idle Disconnect Timeout In Seconds</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.idleDisconnectTimeoutInSeconds"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Max User Duration In Seconds</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.maxUserDurationInSeconds"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Scale Out Cooldown In Seconds</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.scaleOutCooldownInSeconds"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Scale In Cooldown In Seconds</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.scaleInCooldownInSeconds"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Scale Out Adjustment</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.scaleOutAdjustment"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Scale In Adjustment</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.scaleInAdjustment"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Min Available Capacity Alarm Threshold</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.minAvailableCapacityAlarmThreshold"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Min Available Capacity Alarm Evaluation Periods</mat-label>
                    <input type="number" matInput
                        [(ngModel)]="createFleetDefinitionRequest.minAvailableCapacityAlarmEvaluationPeriods"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Max Available Capacity Alarm Threshold</mat-label>
                    <input type="number" matInput [(ngModel)]="createFleetDefinitionRequest.maxAvailableCapacityAlarmThreshold"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Max Available Capacity Alarm Evaluation Periods</mat-label>
                    <input type="number" matInput
                        [(ngModel)]="createFleetDefinitionRequest.maxAvailableCapacityAlarmEvaluationPeriods"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <section>
                    <mat-checkbox [(ngModel)]="createFleetDefinitionRequest.usesLegacySessionContext"
                        [ngModelOptions]="{standalone: true}">Uses Legacy Session Context</mat-checkbox>
                </section>
            </div>
        </form>
    </div>
    <div *ngIf="createFleetDefinitionResponse">
        <label>Fleet Id: {{createFleetDefinitionResponse.fleetId}}</label> <br />
        <label>Stack Id: {{createFleetDefinitionResponse.stackId}}</label>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <!--Dialog action buttons-->
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving"
        *ngIf="!createFleetDefinitionResponse">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
    </button>
    <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
</mat-dialog-actions>